<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize">{{ refs }}
                        
                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->
                        
                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Edit</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

            <!-- Loading -->
            <div v-if="pgLoading" class="row h-100">
                <div class="container text-center">
                    <div class="spinner-grow mt-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
            <!-- End Loading -->

            <form v-if="!pgLoading" @submit.prevent="editRow" enctype="multipart/form-data" class="h-100">

            <!-- Content -->
            <div class="tab-content">
                <div class="row">        


                <!-- ******* Card ******** -->
                <div class="col-md-8 mb-5">

                    <!-- Card Meta -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabMeta" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Meta')"
                                        aria-expanded="false" 
                                        aria-controls="collapseMeta" 
                                        data-toggle="collapse"
                                        data-target="#collapseMeta">Meta
                                        <span id="iconToggleMeta" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                            pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseMeta" 
                                    class="collapse show" 
                                    aria-labelledby="TabMeta" 
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- Meta title -->
                                        <div class="form-group">
                                            <div class="pull-right f12" 
                                                v-if="row.meta_title"
                                                v-text="(row.meta_title.length)">
                                            </div>
                                            <label for="inputMeta1">Meta title</label>
                                            <input class="form-control"
                                                    id="inputMeta1"  
                                                    type="text" 
                                                    v-model="row.meta_title">
                                        </div>
                                        <!-- End Meta title -->
                                            
                                        <!-- Meta keywords -->
                                        <div class="form-group">
                                            <div class="pull-right f12"
                                                v-if="row.meta_keywords" 
                                                v-text="(row.meta_keywords.length)">
                                            </div>
                                            <label for="inputMeta2">Meta keywords</label>
                                            <textarea class="form-control"
                                                    id="inputMeta2" 
                                                    rows="5"  
                                                    v-model="row.meta_keywords">
                                            </textarea>
                                        </div>
                                        <!-- End Meta keywords -->

                                        <!-- Meta description -->
                                        <div class="form-group">
                                            <div class="pull-right f12" 
                                                v-if="row.meta_description" 
                                                v-text="(row.meta_description.length)">
                                            </div>
                                            <label for="inputMeta3">Meta description</label>
                                            <textarea class="form-control" 
                                                    id="inputMeta3" 
                                                    rows="5" 
                                                    v-model="row.meta_description">
                                            </textarea>
                                        </div>
                                        <!-- End Meta description -->

                                    </div>

                                        <div class="row">
                                            <div class="col-6 pt-3">
                                                <!-- Site Map Changefreq -->
                                                <div class="form-group">
                                                    <label for="inputText444">Site Map Changefreq</label>
                                                    <select class="form-control" 
                                                            id="inputText444" 
                                                            v-model="row.sitemap_freq">
                                                        <option value="always">always</option>
                                                        <option value="hourly">hourly</option>
                                                        <option value="daily">daily</option>
                                                        <option value="weekly">weekly</option>
                                                        <option value="monthly" selected>monthly</option>
                                                        <option value="yearly">yearly</option>
                                                        <option value="never">never</option>
                                                    </select>
                                                </div>
                                                <!-- Site Map Changefreq -->
                                            </div>

                                            <div class="col-6 pt-3">
                                                <!-- Site Map Priority -->
                                                    <div class="form-group">
                                                        <label for="inputText555">Site Map Priority</label>
                                                        <select class="form-control" 
                                                                id="inputText555" 
                                                                v-model="row.sitemap_priority">
                                                            <option value="0.0">0.0</option>
                                                            <option value="0.1">0.1</option>
                                                            <option value="0.2">0.2</option>
                                                            <option value="0.3">0.3</option>
                                                            <option value="0.4">0.4</option>
                                                            <option value="0.5" selected>0.5</option>
                                                            <option value="0.6">0.6</option>
                                                            <option value="0.7">0.7</option>
                                                            <option value="0.8">0.8</option>
                                                            <option value="0.9">0.9</option>
                                                            <option value="1.0">1.0</option>
                                                        </select>
                                                    </div>
                                                <!-- End Site Map Priority -->
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Meta -->

                    <!-- Card Wiki -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabWiki" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Wiki')"
                                        aria-expanded="false" 
                                        aria-controls="collapseWiki" 
                                        data-toggle="collapse"
                                        data-target="#collapseWiki">Wiki
                                        <span id="iconToggleWiki" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseWiki" 
                                    class="collapse" 
                                    aria-labelledby="TabWiki" 
                                    data-parent="#accordion">

                                <div class="col-12 pt-3">
                                    
                                     <!-- Title -->
                                    <div class="form-group">
                                        <label for="inputWiki1">Title</label>
                                        <input class="form-control" 
                                                id="inputWiki1" 
                                                type="text" 
                                                v-model="row.title">
                                    </div>
                                    <!-- End Title -->

                                    <!-- Slug -->
                                    <div class="form-group">
                                        <label for="inputWiki2">Slug</label>
                                        <input class="form-control"
                                                id="inputWiki2"  
                                                type="text" 
                                                v-model="row.slug" 
                                                @keydown.space.prevent>
                                    </div>
                                    <!-- End Slug -->

                                    <!-- Sort -->
                                    <div class="form-group">
                                        <label for="inputWiki3">Sort</label>
                                        <input class="form-control" 
                                                id="inputWiki3" 
                                                type="number" 
                                                min="0"
                                                v-model.number="row.sort">
                                    </div>
                                    <!-- End Sort -->

                                    <!-- Short Body -->
                                    <div class="form-group">
                                        <label for="inputEditor1">Short body</label>
                                        <editor
                                            id="inputEditor1"
                                            v-model="row.short_body"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Short Body -->

                                    <!-- Body -->
                                    <div class="form-group">
                                        <label for="inputEditor2">Body</label>
                                        <editor
                                            id="inputEditor2"
                                            v-model="row.body"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 600,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Wiki -->


                    <!-- Card Wiki Items -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabItems" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Items')"
                                        aria-expanded="false" 
                                        aria-controls="collapseItems" 
                                        data-toggle="collapse"
                                        data-target="#collapseItems">Items
                                        <span id="iconToggleItems" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseItems" 
                                    class="collapse" 
                                    aria-labelledby="TabItems" 
                                    data-parent="#accordion">

                                <div class="col-12 pt-3">
                                
                                <!-- For Loop -->
                                <div v-for="i in row.items_key" 
                                    :key="'i'+i" 
                                    :ref="'frm_'+i" 
                                    :id="'frm_'+i"
                                    :class="(i == 0) ? 'hidden' : '' "
                                    class="ui-for-div">

                                    <!-- Remove -->
                                    <div class="pull-right ui-mt-10">
                                        <button v-if="i != 0"
                                            type="button" 
                                            class="btn btn-danger btn-circle btn-with-icon btn-sm" 
                                            @click="removeOption(i)">
                                            <span class="btn-icon ti-close font-bold"></span>
                                        </button>
                                    </div>
                                    <!-- End Remove -->

                                    <!-- Title -->
                                    <div class="form-group">
                                        <label :for="'inputItems'+i">Title</label>
                                        <input class="form-control" 
                                                :id="'inputItems'+i" 
                                                type="text" 
                                                v-model="row.items_title[i]">
                                    </div>
                                    <!-- End Title -->

                                    <!-- Sort -->
                                    <div class="form-group">
                                        <label :id="'inputItems'+i">Sort</label>
                                        <input class="form-control" 
                                                :id="'inputItems'+i" 
                                                type="number"
                                                min="0" 
                                                v-model.number="row.items_sort[i]">
                                    </div>
                                    <!-- End Sort -->

                                    <!-- Body -->
                                    <div class="form-group">
                                        <label :for="'editorItems'+i">Body</label>
                                        <editor
                                            :id="'editorItems'+i"
                                            v-model="row.items_body[i]"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Short Body -->

                                    <!-- image -->
                                    <div class="form-group">
                                        <label :for="'inputImage'+i">Image</label>
                                        <p>
                                            <img v-if="row.items_image_preview[i]" 
                                                :src="row.items_image_preview[i]"
                                                class="custom-image">
                                        </p>
                                        <input class="form-control" 
                                                :id="'inputImage'+i" 
                                                type="file"
                                                v-on:change="onItemsImageChange($event, i)">
                                    </div>
                                    <!-- End image -->

                                    <!-- image alt -->
                                    <div class="form-group">
                                        <label :for="'inputImageAlt'+i">Image alt</label>
                                        <input class="form-control" 
                                                :id="'inputImageAlt'+i" 
                                                type="text" 
                                                v-model="row.items_image_alt[i]">
                                    </div>
                                    <!-- End image alt -->

                                    <!-- image title -->
                                    <div class="form-group">
                                        <label :for="'inputImageTitle'+i">Image title</label>
                                        <input class="form-control" 
                                                :id="'inputImageTitle'+i" 
                                                type="text" 
                                                v-model="row.items_image_title[i]">
                                    </div>
                                    <!-- End image title -->

                                    <!-- position image -->
                                    <div class="form-group">
                                        <label :for="'input50'+i">Position Image</label>
                                        <div class="custom-control custom-switch col-3 p-0">
                                            <select class="form-control custom-select" :id="'input50'+i"
                                                    v-model="row.items_position_image[i]">
                                                    <option value="">Select Position</option>
                                                    <option value="UP">UP</option>
                                                    <option value="Down">Down</option>
                                                    <option value="Right">Right</option>
                                                    <option value="Left">Left</option>
                                            </select>
                                        </div>
                                    </div>
                                    <!-- End position image -->

                                    <div class="form-group">
                                        <label>Linked FAQs (this block)</label>
                                        <p class="text-muted small mb-1">Order follows selection order.</p>
                                        <div v-if="faqsLoading" class="text-center">
                                            <span class="spinner-grow spinner-grow-sm mr-1" 
                                                role="status" 
                                                aria-hidden="true">
                                            </span>
                                        </div>
                                        <multiselect v-if="!faqsLoading"
                                            :id="'multiselect-faqs-wiki-item-'+i"
                                            :value="row.items_faqs[i] || []"
                                            @input="val => $set(row.items_faqs, i, val)"
                                            :options="faqsOptions" 
                                            :multiple="true"
                                            :close-on-select="false" 
                                            :clear-on-select="false" 
                                            :hide-selected="true" 
                                            :preserve-search="true" 
                                            :taggable="false"
                                            label="title"
                                            track-by="id"
                                            placeholder="Search and select FAQs"
                                            :preselect-first="false">
                                        </multiselect>
                                    </div>

                                </div>
                                <!-- End Loop -->

                                    <!-- Button -->
                                    <div class="row pull-right ui-mt15">
                                        <button type="button" 
                                            class="btn btn-dark btn-circle btn-with-icon"
                                            @click="opnFrm()">
                                            <span class="btn-icon ti-plus font-bold"></span>
                                        </button>
                                    </div>
                                    <!-- End Button -->

                                </div>
                            
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Items -->


                </div>
                <!-- ******* End Card ******** -->


                <!-- ******* SideNavbar ******** -->
                <div class="col-md-4 mb-5">

                    <!-- Nav Destination -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavDestination" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('NavDestination')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavDestination" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavDestination">Destination
                                        <span id="iconToggleNavDestination" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                            pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                
                                <div id="collapseNavDestination" 
                                    class="collapse" 
                                    aria-labelledby="NavDestination" 
                                    data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        
                                        <!-- Destinations -->
                                        <div class="form-group">
                                            <div v-if="destinationLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                    v-if="!destinationLoading" 
                                                    v-model="row.destination_id">
                                                    <option value="">Select Destination</option>
                                                    <optgroup v-for="(region, index) in destinations" 
                                                            :key="index"
                                                            :label="region.title">
                                                        <option v-for="(destination,idx) in region.destinations"
                                                            :key="idx"
                                                            :value="destination.id">
                                                            {{ destination.title }}
                                                        </option>
                                                    </optgroup>
                                            </select>
                                        </div>
                                        <!-- End Destination -->
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Destination -->

                    <!-- Nav Packages -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavPackages" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('NavPackages')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavPackages" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavPackages">Related Packages
                                        <span id="iconToggleNavPackages" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                            pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavPackages" 
                                    class="collapse" 
                                    aria-labelledby="NavPackages" 
                                    data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        
                                        <!-- Packages -->
                                        <div class="form-group">
                                            <div v-if="packageLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!packageLoading"
                                                id="multiselect"
                                                ref="multiselectRef"
                                                autocomplete="on"
                                                v-model="row.packagesValues" 
                                                :options="packagesOptions" 
                                                :multiple="true"
                                                :close-on-select="false" 
                                                :clear-on-select="false" 
                                                :hide-selected="true" 
                                                :preserve-search="true" 
                                                :taggable="false"
                                                placeholder="Type to search packages"
                                                :preselect-first="false">
                                            </multiselect>
                                        </div>
                                        <!-- End Packages -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Packages -->

                    <!-- Nav Multiple Related Articles -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavRelatedArticles" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('RelatedArticles')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavRelatedArticles"
                                        data-toggle="collapse"
                                        data-target="#collapseNavRelatedArticles">Multiple Related Articles
                                        <span id="iconToggleRelatedArticles"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow
                                            pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavRelatedArticles"
                                    class="collapse"
                                    aria-labelledby="NavRelatedArticles"
                                    data-parent="#accordionNav">

                                    <div class="col-12 pt-3">

                                        <!-- Related Articles -->
                                        <div class="form-group">
                                            <div v-if="relatedArticlesLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1"
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!relatedArticlesLoading"
                                                id="multiselect"
                                                ref="multiselectRef"
                                                autocomplete="on"
                                                v-model="row.relatedArticlesValues"
                                                :options="relatedArticlesOptions"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :hide-selected="true"
                                                :preserve-search="true"
                                                :taggable="false"
                                                placeholder="Type to search related articles"
                                                :preselect-first="false">
                                            </multiselect>
                                        </div>
                                        <!-- End Related Articles -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Related Articles -->

                    <!-- Nav Multiple Tags -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleTags" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('MultipleTags')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavMultipleTags" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavMultipleTags">Multiple Tags
                                        <span id="iconToggleMultipleTags" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleTags" 
                                    class="collapse" 
                                    aria-labelledby="NavMultipleTags" 
                                    data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="tagsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!tagsLoading"
                                                    id="multiselect"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.tagsValues" 
                                                    :options="tagsOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    placeholder="Type to search tags"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Tags -->

                    <!-- Nav Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavImage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Image')"  
                                        aria-expanded="false" 
                                        aria-controls="collapseNavImage" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavImage">Featued Image
                                        <span id="iconToggleImage" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                            pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavImage" 
                                    class="collapse" 
                                    aria-labelledby="NavImage" 
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                    
                                        <!-- Image -->
                                        <div class="form-group">
                                            <label>Image</label>
                                            <img v-if="row.image_preview" 
                                                :src="row.image_preview" 
                                                class="mb-2 custom-image">
                                            <input type="file" 
                                                class="form-control" 
                                                ref="myDropify" 
                                                v-on:change="onImageChange"
                                                accept="image/*">
                                        </div>
                                        <!-- End Image -->

                                        <!-- Image Alt -->
                                        <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_alt">
                                        </div>
                                        <!-- End Image Alt -->

                                        <!-- Image Title -->
                                        <div class="form-group">
                                                <label>Image title</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_title">
                                        </div>
                                        <!-- End Image Title -->
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Image -->

                    <!-- Nav Mobile Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="MobileNavImage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('MobileImage')"  
                                        aria-expanded="false" 
                                        aria-controls="collapseMobileNavImage" 
                                        data-toggle="collapse" 
                                        data-target="#collapseMobileNavImage">Mobile Featured Image
                                        <span id="iconToggleMobileImage" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseMobileNavImage" 
                                    class="collapse" 
                                    aria-labelledby="MobileNavImage" 
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                            <!-- Image -->
                                        <div class="form-group">
                                            <label>Image</label>
                                            <img v-if="row.mobile_image_preview"
                                                :src="row.mobile_image_preview" 
                                                class="mb-2 custom-image">
                                            <input type="file" 
                                                class="form-control" 
                                                ref="myDropify" 
                                                v-on:change="onMobileImageChange"
                                                accept="image/*">
                                        </div>
                                        <!-- Image -->

                                        <!-- Image Alt -->
                                        <div class="form-group">
                                            <label>Image alt</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.mobile_image_alt">
                                        </div>
                                        <!-- End Image Alt -->

                                        <!-- Image Title -->
                                        <div class="form-group">
                                            <label>Image title</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.mobile_image_title">
                                        </div>
                                        <!-- End Image Title -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Mobile Image -->

                    <!-- Nav Short Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavShortImage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('ShortImage')"  
                                        aria-expanded="false" 
                                        aria-controls="collapseNavShortImage" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavShortImage">Short Image
                                        <span id="iconToggleShortImage" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavShortImage" 
                                        class="collapse" 
                                        aria-labelledby="NavShortImage" 
                                        data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        
                                        <!-- Image -->
                                        <div class="form-group">
                                            <label>Image</label>
                                            <img :src="row.short_image_preview" 
                                                class="mb-2 custom-image">
                                            <input type="file" 
                                                class="form-control" 
                                                ref="myDropify" 
                                                v-on:change="onShortImageChange"
                                                accept="image/*">
                                        </div>
                                        <!-- Image -->

                                        <!-- Image alt -->
                                        <div class="form-group">
                                            <label>Image alt</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.short_image_alt">
                                        </div>
                                        <!-- End Image alt -->

                                        <!-- Image title -->
                                        <div class="form-group">
                                            <label>Image title</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.short_image_title">
                                        </div>
                                        <!-- End Image title -->
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Short Image -->

                    <!-- Nav Status -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavStatus" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Status')"
                                        aria-expanded="false" 
                                        aria-controls="collapseNavStatus" 
                                        data-toggle="collapse"
                                        data-target="#collapseNavStatus">Status & Visibility
                                        <span id="iconToggleStatus" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                            pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavStatus" 
                                    class="collapse" 
                                    aria-labelledby="NavStatus" 
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                        
                                        <!-- Status -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch1" 
                                                    :checked="row.status"
                                                    @click="onStatus">
                                                <label class="custom-control-label" 
                                                    for="customSwitch1"
                                                    v-html="(row.status) ? 'Active' : 'Inactive'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Status -->

                                        <!-- View in home -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch2" 
                                                    :checked="row.view_in_home"
                                                    @click="onViewInHome">
                                                <label class="custom-control-label" 
                                                    for="customSwitch2"
                                                    v-html="(row.view_in_home) 
                                                        ? 'Show In Home' 
                                                        : 'Hide In Home'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End View in home -->
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Status -->

                </div>
                <!-- ******* SideNavbar ******** -->


                </div>
            </div>
            <!-- End Content -->


                <!-- Buttons -->
                <div class="col-md-12 row">
                    <div class="form-group mr-2">
                        <button class="btn btn-primary" :disabled="btnLoading">
                            <span v-if="btnLoading">
                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                    role="status" aria-hidden="true">
                                </span>Loading...
                            </span>
                            <span v-if="!btnLoading" class="ti-check-box"></span>
                            <span v-if="!btnLoading" class="text-capitalize"> Update {{ refs }}</span>
                        </button>
                    </div>

                    <div class="form-group">
                        <button type="button" class="btn btn-danger" 
                            :disabled="btnLoading" 
                            @click="cancel">
                            <span class="ti-close"></span>
                            <span> Cancel </span>
                        </button>
                    </div>
                </div>
                <!-- End Buttons -->


                </form>
            </div>

                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import Multiselect from 'vue-multiselect';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Edit',
        components: {
            Header,
            Navigation,
            Footer,
            Multiselect,
            Editor
        },
        data(){
            return {
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    // meta
                    meta_title: '',
                    meta_keywords: '',
                    meta_description: '',

                    //sitemap
                    sitemap_freq: 'monthly',
                    sitemap_priority: 0.5,

                    // row
                    slug: '',
                    title: '',
                    sort: 0,
                    body: '',
                    short_body: '',

                    // items
                    items: [],
                    items_key: 0,
                    items_title: [],
                    items_sort: [],
                    items_body: [],
                    items_image_preview: [],
                    items_image_base64: [],
                    items_image_alt: [],
                    items_image_title: [],
                    items_position_image: [],
                    items_faqs: [],

                    // navbar
                    destination_id: '',
                    packagesValues: [],
                    relatedArticlesValues: [],
                    tagsValues: [],

                    // image
                    image_preview: '',
                    image_base64: '',
                    image_alt: '',
                    image_title: '',

                    // mobile image
                    mobile_image_preview: '',
                    mobile_image_base64: '',
                    mobile_image_alt: '',
                    mobile_image_title: '',

                    // short image
                    short_image_preview: '',
                    short_image_base64: '',
                    short_image_alt: '',
                    short_image_title: '',

                    // status & visibility
                    status: 1,
                    view_in_home: 0,
                },
                editor: {
                    api_key: window.editor_apiKey,
                    menubar: window.editor_menubar,
                    plugins:[window.editor_plugins],
                    external_plugins: window.editor_external_plugins,
                    toolbar: window.editor_toolbar,
                },

                // destinations
                destinationLoading: true,
                destinations: [],

                // multiple tags
                tagsOptions: [],
                tagsLoading: true,

                // packages
                packageLoading: true,
                packagesOptions: [],

                // multiple related articles
                relatedArticlesOptions: [],
                relatedArticlesLoading: true,

                faqsOptions: [],
                faqsLoading: true,

                pgLoading: true,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'wikis'
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

             // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchFaqs().then(() => { this.fetchRow(); });
        },
        methods: {
            
            fetchFaqs(){
                this.faqsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/faqs',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 1000,
                    },
                };
                return this.axios(options)
                    .then(res => {
                        this.faqsOptions = res.data.rows || [];
                    })
                    .catch(() => { this.faqsOptions = []; })
                    .finally(() => { this.faqsLoading = false; });
            },
            
            // fetch Row
            fetchRow() {
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                    method: 'GET',
                    data: {},
                    params: {},
                }
                this.axios(options)
                    .then(res => {
                    this.pgLoading = false;

                    // tenant
                    this.tenant_id = res.data.row.tenant_id;
                    this.tenant_name = res.data.row.tenant_name;

                    // meta
                    this.row.meta_title = (res.data.row.meta) ? res.data.row.meta.meta_title : null;
                    this.row.meta_keywords = (res.data.row.meta) ? res.data.row.meta.meta_keywords : null;
                    this.row.meta_description = (res.data.row.meta) ? res.data.row.meta.meta_description : null;

                    //sitemap
                    this.row.sitemap_freq = res.data.row.sitemap_freq; 
                    this.row.sitemap_priority = res.data.row.sitemap_priority;

                    // row
                    this.row.slug = res.data.row.slug;
                    this.row.title = res.data.row.title;
                    this.row.sort = res.data.row.sort;
                    this.row.body = res.data.row.body;
                    this.row.short_body = res.data.row.short_body;

                    // items
                    this.row.items_key = res.data.row.items.length;
                    if(res.data.row.items) {
                        for(let i = 1; i <= this.row.items_key; i++) {
                            let x = i-1;
                            this.row.items_title[i] = res.data.row.items[x].title;
                            this.row.items_body[i] = res.data.row.items[x].body;
                            this.row.items_sort[i] = (res.data.row.items[x].sort)
                                                        ? res.data.row.items[x].sort
                                                        : 0;

                            this.row.items_image_preview[i] = (res.data.row.items[x].image) 
                                                        ? res.data.row.items[x].image.image_url
                                                        : null;
                            this.row.items_image_base64[i] = (res.data.row.items[x].image) 
                                                        ? res.data.row.items[x].image.image_url
                                                        : null;
                            this.row.items_image_alt[i] = (res.data.row.items[x].image) 
                                                        ? res.data.row.items[x].image.image_alt
                                                        : null;
                            this.row.items_image_title[i] = (res.data.row.items[x].image) 
                                                        ? res.data.row.items[x].image.image_title
                                                        : null;
                            this.row.items_position_image[i] = (res.data.row.items[x].image)
                                                        ? res.data.row.items[x].image.position_image
                                                        : '';
                            this.$set(this.row.items_faqs, i, []);
                            if (res.data.row.items[x].faqs && res.data.row.items[x].faqs.length) {
                                const f = res.data.row.items[x].faqs;
                                if (typeof f[0] === 'object' && f[0] !== null && f[0].id !== undefined) {
                                    this.$set(this.row.items_faqs, i, f.slice());
                                } else {
                                    this.$set(this.row.items_faqs, i,
                                        f.map(id => this.faqsOptions.find(o => o.id === id)).filter(Boolean));
                                }
                            }
                        }
                    }

                    // navbar
                    this.row.destination_id = (res.data.row.destination) ? res.data.row.destination.id : null;
                    this.row.packagesValues = (res.data.row.packagesValues) ?? [];
                    this.row.relatedArticlesValues = (res.data.row.related_articles) ? res.data.row.related_articles : [];
                    this.row.tagsValues = (res.data.row.tagsValues) ? res.data.row.tagsValues : [];

                    // image
                    this.row.image_preview = (res.data.row.image) ? res.data.row.image.image_url : null;
                    this.row.image_base64 = (res.data.row.image) ? res.data.row.image.image_url : null;
                    this.row.image_alt = (res.data.row.image ) ? res.data.row.image.image_alt : null;
                    this.row.image_title = (res.data.row.image ) ? res.data.row.image.image_title : null;

                    // mobile image
                    this.row.mobile_image_preview = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_url : null;
                    this.row.mobile_image_base64 = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_url : null;
                    this.row.mobile_image_alt = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_alt : null;
                    this.row.mobile_image_title = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_title : null;

                    this.row.short_image_preview = (res.data.row.short_image) 
                                                    ? res.data.row.short_image.image_url 
                                                    : null;
                    this.row.short_image_base64 = (res.data.row.short_image) 
                                                    ? res.data.row.short_image.image_url 
                                                    : null;
                    this.row.short_image_alt = (res.data.row.short_image) 
                                                    ? res.data.row.short_image.image_alt 
                                                    : null;
                    this.row.short_image_title = (res.data.row.short_image) 
                                                    ? res.data.row.short_image.image_title 
                                                    : null;

                    // status & visibility
                    this.row.status = res.data.row.status;
                    this.row.view_in_home = res.data.row.view_in_home;

                    this.fetchDestinations(); // call next fun
                    })
                    .catch(err => {
                        this.btnLoading = false;
                        iziToast.warning({
                            icon: 'ti-alert',
                            title: 'Wow-man,',
                            message: (err.response) ? err.response.data.message : ''+err
                        });
                    })
                    .finally(() => {});
            },

            // fetch Destinations
            fetchDestinations(){
                this.destinationLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/regions',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.destinationLoading = false;
                        this.destinations = res.data.rows;
                        this.fetchTags(); // call packages
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // fetchMultipleTags
            fetchTags(){
                this.tagsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/tags',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.tagsLoading = false;
                    this.tagsOptions = res.data.tags;
                    this.fetchPackages(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // Fetch Packages
            fetchPackages(){
                this.packageLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/packages',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.packageLoading = false;
                        this.packagesOptions = res.data.packages;
                        this.fetchRelatedArticles(); // call next function
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // Related Articles
            fetchRelatedArticles(){
                this.relatedArticlesLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/articles',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.relatedArticlesLoading = false;
                        this.relatedArticlesOptions = res.data.articles;
                    })
                    .catch(() => {})
                    .finally(() => {});
            },


            // edit Row
            editRow(){
                if(this.tenant_id == 0) {
                    
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenany selected.'
                    });

                } else {
                    this.btnLoading = true;
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer ` + this.auth.access_token,
                    };

                    // items
                    for( let i = 1; i <= this.row.items_body.length; i++ ) {
                        if (this.row.items_body[i] != "") {
                            const itemFaqs = this.row.items_faqs[i] || [];
                            this.row.items[i] = {
                                'title' : this.row.items_title[i],
                                'body' : this.row.items_body[i],
                                'sort' : this.row.items_sort[i],

                                'image_base64' : this.row.items_image_base64[i],
                                'image_alt' : this.row.items_image_alt[i],
                                'image_title' : this.row.items_image_title[i],
                                'position_image' : this.row.items_position_image[i],
                                'faqs': itemFaqs.map(f => (f && f.id !== undefined) ? f.id : f)
                            }
                        }
                    }

                    const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                    const options = {
                        url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                        method: 'PUT',
                        data: {
                            tenant_id: this.tenant_id,
                            // meta
                            meta_title: this.row.meta_title,
                            meta_keywords: this.row.meta_keywords,
                            meta_description: this.row.meta_description,

                            //sitemap
                            sitemap_freq: this.row.sitemap_freq,
                            sitemap_priority:   this.row.sitemap_priority,

                            // row
                            title: this.row.title,
                            slug: this.row.slug,
                            sort: this.row.sort,
                            body: this.row.body,
                            short_body: this.row.short_body,

                            // items
                            items: this.row.items,

                            // navbar
                            destination_id: this.row.destination_id,
                            packages: this.row.packagesValues,
                            related_articles: this.row.relatedArticlesValues,
                            tags: this.row.tagsValues,

                            // image
                            image_base64: this.row.image_base64,
                            image_alt: this.row.image_alt,
                            image_title: this.row.image_title,

                            // mobile image 
                            mobile_image_base64: this.row.mobile_image_base64,
                            mobile_image_alt: this.row.mobile_image_alt,
                            mobile_image_title: this.row.mobile_image_title,

                            // short image
                            short_image_base64: this.row.short_image_base64,
                            short_image_alt: this.row.short_image_alt,
                            short_image_title: this.row.short_image_title,

                            // status & visibility
                            status: this.row.status,
                            view_in_home: this.row.view_in_home,
                        }
                    }
                    this.axios(options, config)
                        .then(() => {
                            this.btnLoading = false;
                            iziToast.success({
                                icon: 'ti-check',
                                title: 'Great job,',
                                message: 'Item Updated Successfully.',
                            });
                            this.$router.push({ name: this.refs });
                        })
                        .catch(err => {
                            // 403 Forbidden
                            if(err.response && err.response.status == 401) {
                                this.removeLocalStorage();
                                this.$router.push({ name: 'login' });
                            } else if(err.response && err.response.status == 403) {
                                this.$router.push({ name: 'forbidden' });
                            } else {
                                this.btnLoading = false;
                                iziToast.warning({
                                    icon: 'ti-alert',
                                    title: 'Wow-man,',
                                    message: (err.response) ? err.response.data.message : ''+err
                                });
                            }
                        })
                        .finally(() => {})
                }
            },


            // Title
            onTitleChange() {
                // this.onSlugChange(this.row.title);
            },

            // on Paste
            onSlugPaste(){
                let str = this.row.slug;
                this.onSlugChange(str);
            },
            onSlugChange(str){
                if(!str) {
                   let str = this.row.slug;
                   this.row.slug = str.replace(/\s+/g, '-');
                } else {
                    this.row.slug = str.replace(/\s+/g, '-');
                }
            },

            
            
            // items add more
            opnFrm() {
               this.row.items_key++;
               this.$set(this.row.items_faqs, this.row.items_key, []);
            },
            removeOption(i) {
                document.querySelector('#frm_'+i).remove();
                this.row.items_title[i] = '';
                this.row.items_sort[i] = '';
                this.row.items_body[i] = '';
                this.row.items_image_preview[i] = '';
                this.row.items_image_base64[i] = '';
                this.row.items_image_alt[i] = '';
                this.row.items_image_title[i] = '';
                this.row.items_position_image[i]= '';
                this.$set(this.row.items_faqs, i, []);
            },


            // Upload Featured image
            onImageChange(e){
                const file = e.target.files[0];
                this.row.image_preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image_base64 = e.target.result;
                };
            },
            onShortImageChange(e){
                const file = e.target.files[0];
                this.row.short_image_preview = URL.createObjectURL(file);
                this.createBase64ShortImage(file);
            },
            createBase64ShortImage(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.short_image_base64 = e.target.result;
                };
            },

            onItemsImageChange(e, i) {
                const file = e.target.files[0];
                this.row.items_image_preview[i] = URL.createObjectURL(file);
                this.createItemsBase64Image(file, i);
            },
            createItemsBase64Image(fileObject, i){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.items_image_base64[i] = e.target.result;
                };
            },

            // Upload Mobile Featured image
            onMobileImageChange(e){
                const file = e.target.files[0];
                this.row.mobile_image_preview = URL.createObjectURL(file);
                this.createBase64MobileImage(file);
            },
            createBase64MobileImage(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.mobile_image_base64 = e.target.result;
                };
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },
            // view in home
            onViewInHome(){
                if(this.row.view_in_home)
                    this.row.view_in_home = 0;
                else
                    this.row.view_in_home = 1;
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // toggleCollapse
            collapseToggle(div) {
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
